import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Icon } from '@iconify/react'

// antd
import { Row, Typography, Upload, message, theme } from 'antd'
import { PlusOutlined } from '@ant-design/icons'

// assets
import { FileAddIcon } from '../../assets/icons'

// slices
import {
    getS3UrlForAttachment,
    taskFileError,
    taskFilesRemove,
    taskFilesUpload,
    tasksState,
} from './tasks.slice'

// constants
import { fileTypes, pdfTypes, videoTypes } from '../../constants/mediaTypes'

import dayjs from 'dayjs'

// styles
import styles from './tasks.module.css'
import { uploadAttachmentToAWS } from './tasks.service'
import MediaViewer from './components/mediaViewer'

const AttachmentFileSection = ({ taskUpdateFilesCallback }) => {
    const { Title } = Typography

    const { useToken } = theme
    const { token } = useToken()

    const dispatch = useDispatch()

    const { taskFiles, selectedTask, selectedSubTask, formSubTask, fileError } =
        useSelector(tasksState)

    const [stream, setStream] = useState(false)
    const [fileURL, setFileURL] = useState([])

    useEffect(() => {
        if (selectedSubTask && formSubTask) {
            dispatch(taskFilesRemove(selectedSubTask?.attachment))
            setFileURL(selectedSubTask?.attachment)
        } else if (selectedTask) {
            dispatch(taskFilesRemove(selectedTask?.attachment))
            setFileURL(selectedTask?.attachment)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedTask, selectedSubTask, formSubTask])

    const uploadButton = (
        <div>
            <PlusOutlined />
        </div>
    )

    // UPLOADING BUTTON
    const uploadButtonLoading = (
        <div
            className={styles.uploadButtonBox}
            style={{
                border: '1px solid #edeae9',
            }}
        >
            <Icon
                icon="line-md:uploading-loop"
                width={26}
                height={26}
                color={token.colorPalette.baseColor.tertiary}
            />
        </div>
    )

    const props = {
        name: 'files',
        multiple: true,
        async onChange(info) {
            if (fileError?.length === 0) {
                setStream(true)

                const nameChange = info?.file?.name
                    .split('.')[0]
                    .concat(`_${dayjs(new Date()).unix()}`)
                    .concat(
                        `.${
                            info?.file?.name.split('.')[
                                info?.file?.name.split('.')?.length - 1
                            ]
                        }`
                    )

                const newFileData = new File([info?.file], nameChange, {
                    type: info?.file?.type,
                })
                window.Buffer = window.Buffer || require('buffer').Buffer

                const formData = {
                    data: [
                        {
                            filename: nameChange,
                            contentType: info?.file?.type,
                        },
                    ],
                }

                const attachmentUrls = dispatch(getS3UrlForAttachment(formData))
                    .then(async (data) => {
                        if (data?.payload?.data?.status === 200) {
                            const response = data?.payload?.data?.data?.data
                            const uploadUrl = response?.[0]?.uploadUrl
                            const publicLink = response?.[0]?.publicLink

                            if (uploadUrl) {
                                const formData = {
                                    url: uploadUrl,
                                    data: info?.file,
                                }
                                await uploadAttachmentToAWS(formData)
                                    .then((resp) => {
                                        console.log('Log ==>then resp', resp)
                                    })
                                    .finally(() => {
                                        setStream(false)
                                    })

                                setFileURL((prevState) => [
                                    ...prevState,
                                    publicLink,
                                ])
                                dispatch(taskFilesUpload(publicLink))
                                taskUpdateFilesCallback(publicLink)
                            } else {
                                message.error(
                                    'Upload Failed!. Please Upload again'
                                )
                                setStream(false)
                            }
                        } else {
                            message.error('Upload Failed!. Please Upload again')
                            setStream(false)
                        }
                    })
                    .finally(() => {
                        setStream(false)
                    })

                // S3FileUpload.uploadFile(newFileData, userProfile?.s3Config)
                //     .then(async (data) => {
                //         // fileUpload = [data?.location, ...fileUpload]
                //         setFileURL((prevState) => [
                //             ...prevState,
                //             data?.location,
                //         ])
                //         dispatch(taskFilesUpload(data?.location))
                //     })
                //     .catch(() => {
                //         message.error('Upload Failed!. Please Upload again')
                //     })
                //     .finally(async () => {
                //         setStream(false)
                //     })
            }
        },
        beforeUpload(file, fileListArray) {
            dispatch(taskFileError(''))

            if (
                taskFiles?.length > 6 ||
                (taskFiles?.length <= 6 &&
                    fileListArray?.length + taskFiles?.length > 6)
            ) {
                dispatch(taskFileError('You can only upload 6 files at most!'))
                return Upload.LIST_IGNORE
            }
            const isLt50M = file.size / 1024 / 1024 < 50
            if (!isLt50M) {
                message.error('Maximum File size would be 50 MB')
                return Upload.LIST_IGNORE
            } else {
                return false
            }
        },
        onDrop() {},
    }

    const handleDelete = (file) => {
        const removeData = [...fileURL]
        removeData.splice(
            removeData.findIndex((item) => item === file),
            1
        )
        setFileURL(removeData)
        dispatch(taskFilesRemove(removeData))
    }

    return (
        <>
            <div
                style={{
                    marginTop: '20px',
                }}
            >
                <Row
                    align={'middle'}
                    style={{
                        columnGap: '6px',
                        width: '100%',
                    }}
                >
                    <FileAddIcon />
                    <Title className="titleSub">Add Files</Title>
                    <span style={{ color: '#363434', marginTop: '8px' }}>
                        (Please upload a{' '}
                        {[...fileTypes, ...videoTypes, ...pdfTypes].join(', ')}{' '}
                        file.)
                    </span>
                </Row>
                <Row
                    style={{
                        width: '100%',
                        flexFlow: 'inherit',
                        marginTop: '20px',
                        columnGap: '10px',
                        rowGap: '10px',
                        flexWrap: 'wrap',
                    }}
                    className="fileTask"
                >
                    {stream && uploadButtonLoading}
                    {taskFiles?.length > 0 && (
                        <MediaViewer
                            mediaFiles={taskFiles}
                            handleDelete={handleDelete}
                        />
                    )}
                    <Upload
                        listType="picture-card"
                        accept={[...fileTypes, ...videoTypes, ...pdfTypes]}
                        {...props}
                        fileList={[]}
                        rootClassName={styles.taskUploadAttachment}
                        // showUploadList={{
                        //     showPreviewIcon: false,
                        // }}
                        className="attachmentUploadWrapper"
                    >
                        {uploadButton}
                    </Upload>
                </Row>
                {fileError &&
                    (typeof fileError === 'string'
                        ? fileError.length > 0
                        : fileError?.error || fileError?.message) && (
                        <span style={{ color: 'red', margin: 2 }}>
                            {typeof fileError === 'string'
                                ? fileError
                                : fileError?.error ||
                                  fileError?.message ||
                                  JSON.stringify(fileError)}
                        </span>
                    )}
            </div>
        </>
    )
}

export default AttachmentFileSection
